export interface MixpanelContextValue {
  trackEvent: (event: string) => void;
}
